module.exports = __webpack_public_path__ + "img/组 126.44d26f45.png";